/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Finalists_DescInputs */



/**
* | output |
* | --- |
* | "winner and finalists" |
*
* @param {Og_Cfg_Finalists_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_finalists_desc = /** @type {((inputs?: Og_Cfg_Finalists_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Finalists_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("vainqueur et finalistes")
	if (locale === "es") return /** @type {LocalizedString} */ ("ganador y finalistas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("vencedor e finalistas")
	if (locale === "it") return /** @type {LocalizedString} */ ("vincitore e finalisti")
	return /** @type {LocalizedString} */ ("winner and finalists")
});